<template>
  <aside
    v-if="showUpsell"
    class="product-upsell"
  >
    <span
      class="product-upsell__heading text-heading-m text-heading-s-desktop"
      v-text="$string('product.upsell.heading')"
    />

    <div class="product-upsell__wrapper">
      <span
        class="product-upsell__custom_title text-body-m-bold"
        v-html="customUpsellTitle"
      />

      <div class="product-upsell__card">
        <div class="product-upsell__image-wrapper">
          <responsive-image
            v-if="productUpsell.media"
            class="product-upsell__image"
            :image="productUpsell.media[0]"
            min-max="70-120"
            :padding="false"
            ratio="1:1"
            sizes="(min-width: 1140px) 25vw, 50vw"
          />
        </div>

        <div class="product-upsell__info">
          <product-vendor
            class="product-upsell__vendor"
            :product="productUpsell"
          />

          <span
            class="product-upsell__product-title text-body-s-bold"
            v-html="productUpsell.title"
          />

          <product-prices
            class="product-upsell__product-price"
            class-compare-at-price="text-other-sale-xs"
            class-price="text-body-xs-regular"
            :available="
              productUpsellVariant?.available
                || productUpsell?.available
            "
            :compare-at-price="
              productUpsellVariant?.compare_at_price
                || productUpsell?.compare_at_price
            "
            :price="productUpsellVariant?.price || productUpsell?.price"
            :varies="productUpsell?.price?.varies"
          />
        </div>
      </div>

      <btn
        class="product-upsell__button"
        :label="$string('product.upsell.button_text')"
        modifiers="primary center"
        modes="light"
        :url="productUpsell.handle"
      />
    </div>
  </aside>
</template>

<script>

/**
 * Vue: Product upsell (product-upsell)
 * -----------------------------------------------------------------------------
 * An add-on to Product Forms which suggests and links to a similar product.
 *
 */

import Btn from '~global/btn/btn'
import ProductVendor from '~async/product-vendor/product-vendor'
import ProductPrices from '~global/product-prices/product-prices'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductUpsell',

  components: {
    Btn,
    ProductPrices,
    ProductVendor,
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
    },
  },

  computed: {

    /**
     * Show / hide upsell.
     * @returns {Boolean}
     */
    showUpsell() {
      return this.customUpsellTitle?.length || this.productUpsell?.length
    },

    /**
     * Compute product-level upsell title metafield.
     * @returns {String}
     */
    customUpsellTitle() {
      return this.product.metafields?.productUpsellTitle
    },

    /**
     * Compute product-level upsell product metafield.
     * @returns {Object}
     */
    productUpsell() {
      return this.product.metafields?.productUpsell
    },

    /**
     * Compute first available variant.
     * @returns {Object}
     */
    productUpsellVariant() {
      return this.product.metafields?.productUpsellVariant
    },
  },
}
</script>

<style lang="scss">
@import './product-upsell';
</style>
